import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { NotificationPreferenceType } from '../types/notification';
import queryClient from '../query-client';

export type UpdateNotificationPreferencesRequest = { type: NotificationPreferenceType; subscribe: boolean }[];

async function updateNotificationPreferences(request: UpdateNotificationPreferencesRequest): Promise<void> {
    const { data } = await api.patch(`/notification-preferences`, request);
    return data;
}

export function useUpdateNotificationPreferences(): UseMutationResult<void, AxiosError, UpdateNotificationPreferencesRequest, unknown> {
    return useMutation(updateNotificationPreferences, {
        onSettled: () => {
            queryClient.invalidateQueries(['user-notification-preferences']);
        },
    });
}
